export enum ToastType {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  WARNING = 'WARNING',
  INFO = 'INFO',
}

export type Toast = {
  id: string;
  message: string;
  type: ToastType;
  createdAt: number;
};
